module.exports = __webpack_public_path__ + "img/obs_water_normal.0b7e07d2.svg";